var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.timezones,"placeholder":_vm.$i18n.t('Search timezone'),"item-text":"name","item-value":"name","flat":"","return-object":"","value":_vm.timezone,"rules":[function (value) { return !!value || this$1.$i18n.t('Required field'); }]},on:{"change":_vm.setTimezone}})}
var staticRenderFns = []

export { render, staticRenderFns }